const SOUND_MUTED_STORAGE_KEY = 'game-sound-muted';

type SoundType = 'button' | 'correct' | 'wrong' | 'lifeline' | 'victory' | 'gameover';

const SOUND_PATHS: Record<SoundType, string> = {
  button: '/sounds/button.wav',
  correct: '/sounds/correct.wav',
  wrong: '/sounds/wrong.wav',
  lifeline: '/sounds/lifeline.wav',
  victory: '/sounds/victory.wav',
  gameover: '/sounds/gameover.wav',
};

const createAudio = (src: string) => {
  const audio = new Audio(src);
  audio.preload = 'auto';
  return audio;
};

export const isSoundMuted = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(SOUND_MUTED_STORAGE_KEY) === 'true';
};

export const toggleSound = (): boolean => {
  const muted = !isSoundMuted();
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(SOUND_MUTED_STORAGE_KEY, muted ? 'true' : 'false');
  }
  return muted;
};

export const playSound = (sound: SoundType): void => {
  if (isSoundMuted()) return;

  const audio = createAudio(SOUND_PATHS[sound]);
  try {
    audio.play()?.catch(() => undefined);
  } catch {
    // Playback unsupported in this environment (e.g. jsdom in tests) - ignore.
  }
};
